import type { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    meta: {
      icon: 'mdi:wallet-outline',
      order: 95,
      title: '监控管理',
    },
    name: 'BalanceMonitor',
    path: '/balance-monitor-management',
    children: [
      {
        name: 'BalAutoRecharge',
        path: '/balance-monitor-auto-recharge',
        component: () =>
          import('#/views/balance-monitor-management/auto-recharge/index.vue'),
        meta: {
          icon: 'mdi:autorenew',
          pageKey: 'BalAutoRecharge',
          title: '余额监控&自动充值',
          keepAlive: true,
        },
      },
      {
        name: 'BalAccountStatusMonitor',
        path: '/account-status-monitor',
        component: () =>
          import(
            '#/views/balance-monitor-management/account-status-monitor/index.vue'
          ),
        meta: {
          icon: 'mdi:shield-alert-outline',
          pageKey: 'BalAccountStatusMonitor',
          title: '账户封停监控',
          keepAlive: true,
        },
      },
      {
        name: 'BalAccountBalanceDailyChange',
        path: '/account-balance-daily-change',
        component: () =>
          import(
            '#/views/balance-monitor-management/account-balance-daily-change/index.vue'
          ),
        meta: {
          icon: 'mdi:chart-line',
          pageKey: 'BalAccountBalanceDailyChange',
          title: '账户余额日环比',
          keepAlive: true,
        },
      },
      {
        name: 'BalLargeRechargeMonitor',
        path: '/large-recharge-monitor',
        component: () =>
          import(
            '#/views/balance-monitor-management/large-recharge-monitor/index.vue'
          ),
        meta: {
          icon: 'mdi:cash-multiple',
          pageKey: 'BalLargeRechargeMonitor',
          title: '账户大额充值监控',
          keepAlive: true,
        },
      },
      {
        name: 'BalLandingUrlMonitor',
        path: '/landing-url-monitor',
        component: () =>
          import(
            '#/views/balance-monitor-management/landing-url-monitor/index.vue'
          ),
        meta: {
          icon: 'mdi:link-variant',
          pageKey: 'BalLandingUrlMonitor',
          title: '投放URL监控',
          keepAlive: true,
        },
      },
      {
        name: 'BalBmAdminMonitor',
        path: '/bm-admin-monitor',
        component: () =>
          import(
            '#/views/balance-monitor-management/bm-admin-monitor/index.vue'
          ),
        meta: {
          icon: 'mdi:account-key-outline',
          pageKey: 'BalBmAdminMonitor',
          title: 'BM管理员监控',
          keepAlive: true,
        },
      },
    ],
  },
]

export default routes
